/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentFramework extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentFramework");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentFramework.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentFramework>): BackgroundJobPayloadForAssessmentFramework {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentFramework(), model);
        BackgroundJobPayloadForAssessmentFramework.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentFramework>): BackgroundJobPayloadForAssessmentFramework {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentFramework.newInstance(<BackgroundJobPayloadForAssessmentFramework> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentFramework) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentFramework.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentFramework): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentFramework.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.violation_count === undefined) {
            this.violation_count = 0;
        }
    }

    /**
     * Assessment ID
     */
    assessment_id: string;

    /**
     * Policy Job ID
     */
    policy_job_id: string;

    /**
     * Policy Job Status
     */
    policy_job_status: string;

    /**
     * Total Count
     */
    total_count: number;

    /**
     * Validation Count
     */
    violation_count: number;

}
